export function mapCountryForDropdown (countries) {
    return countries.map((country) => ({
        value: country.iso3,
        label: country.name,
        languages: country.languages,
    }))
}
